<template>
  <v-col
    cols="12"
    sm="8"
    md="4"
  >
    <div class="white--text text-center text-h5">
      <span class="the-digest">The Digest</span>
      <span class="font-weight-light"> of Human Rights Awards</span>
    </div>

    <div class="mx-2 mt-6">
      <form
        @submit.prevent="register"
        ref="form"
        lazy-validation
      >
        <v-text-field
          v-model="firstName"
          ref="firstName"
          label="First Name"
          color="white"
          required
          dark
        ></v-text-field>
        <v-text-field
          v-model="lastName"
          ref="lastName"
          label="Last Name"
          color="white"
          required
          dark
        ></v-text-field>
        <v-text-field
          v-model="password"
          :rules="passwordRules"
          ref="password"
          label="Password"
          type="password"
          color="white"
          required
          dark
        ></v-text-field>
        <v-text-field
          v-model="passwordConfirmation"
          :rules="passwordConfirmationRules"
          ref="passwordConfirmation"
          label="Confirm Password"
          type="password"
          color="white"
          required
          dark
        ></v-text-field>

        <v-btn
          block
          depressed
          large
          :loading="loading"
          :disabled="loading || !valid"
          type="submit"
          class="mt-6 secondary primary--text"
          >Register</v-btn>
      </form>
    </div>
  </v-col>
</template>

<script>
import messagesMixin from '@/mixins/messagesMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'Register',

  mixins: [messagesMixin],

  data () {
    return {
      firstName: '',
      lastName: '',
      loader: null,
      loading: false,
      password: '',
      passwordConfirmation: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password mustn\'t be less than 6 characters'
      ],
      passwordConfirmationRules: [
        v => !!v || 'Password Confirm is required',
        v => (v && v === this.password) || 'Passwords do not match'
      ]
    }
  },

  mounted () {
    this.$nextTick(this.$refs.firstName.focus)
  },

  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      this.loader = null
    }
  },

  computed: {
    ...mapGetters([
      'isAdmin',
      'user'
    ]),

    valid () {
      return !!this.password && this.password.length >= 6 && this.password === this.passwordConfirmation
    }
  },

  methods: {
    register () {
      this.loader = 'loading'

      this.$store.dispatch('register', {
        first_name: this.firstName,
        last_name: this.lastName,
        is_admin: this.isAdmin,
        password: this.password,
        token: this.$route.params.token
      })
        .then((data) => {
          this.loader = 'loading'

          this.$router.push({ name: 'dashboard' })

          this.showSuccessMessage('User was registered successfully!')
        })
        .catch(error => {
          console.log(error)

          this.loader = 'loading'
        })
    }
  }
}
</script>
